import axiosInstance from "../Shared/Utils/axiosInstance";
import { toast } from "react-toastify";
import { errorToastStyle, successToastStyle } from "../Shared/Utils/ToastUtils";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";
import { mappingFunction } from "./FamilyDashboardService";

export const getIncentiveBasedAshaList = async (
  languageId,
  districtId,
  talukaId,
  phcId,
  subcenterId,
  villageId,
  lgbId,
  areaType,
  uphcId,
  subareaId,
  corporationHead,
  incentiveFor,
  selectedMonth,
  selectedYear,
) => {
  try {
    const accessLevel = [
      { id: 1, name: "State" },
      { id: 2, name: "District" },
      { id: 3, name: "Taluka" },
      { id: 4, name: "PHC" },
      { id: 5, name: "UPHC" },
      { id: 6, name: "Corporation" },
      { id: 7, name: "Multi District" },
    ];

    const access_level_id = sessionStorage.getItem("access_level_id");
    const filteredAccessLevel = accessLevel.filter(
      (level) => level.id === Number(access_level_id)
    );
    const accessLevelName = filteredAccessLevel[0].name;
    const incentive_role = sessionStorage.getItem("incentive_role");    
    const areaId = (areaType === "Urban" || areaType === "शहरी") ? 1 : 2;
    let url = `/api/ashalist/incentives?selectedMonth=${selectedMonth}&selectedYear=${selectedYear}&languageId=${languageId}&areaId=${areaId}&incentiveFor=${incentiveFor}&incentiveRole=${incentive_role}&phcId=${phcId}`;
    const queryParams = () => {
      if (accessLevelName === "State") {
        if (
          !districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return "stateId=1";
        } else if (
          districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `districtId=${districtId}`;
        } else if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "PHC") {
        if (
          !districtId &&
          !talukaId &&
          phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          !districtId &&
          !talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          !districtId &&
          !talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        }
      } else if (accessLevelName === "District") {
        if (
          districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `districtId=${districtId}`;
        } else if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "Multi District") {
        if (
          districtId &&
          !talukaId &&
          !phcId &&
          !lgbId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `districtId=${districtId}`;
        } else if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          !talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      }else if (accessLevelName === "Taluka") {
        if (
          districtId &&
          talukaId &&
          !phcId &&
          !subcenterId &&
          !villageId &&
          !uphcId &&
          !subareaId
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          !subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `phcId=${phcId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          !villageId &&
          areaId === 2
        ) {
          return `subCenterId=${subcenterId}`;
        } else if (
          districtId &&
          talukaId &&
          phcId &&
          subcenterId &&
          villageId &&
          areaId === 2
        ) {
          return `villageId=${villageId}`;
        } else if (
          districtId &&
          lgbId &&
          talukaId &&
          !uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `lgbId=${lgbId}&districtId=${districtId}`;
        } else if (
          districtId &&
          lgbId &&
          talukaId &&
          !uphcId &&
          !subareaId &&
          lgbId === 1 &&
          areaId === 1
        ) {
          return `talukaId=${talukaId}`;
        } else if (
          districtId &&
          lgbId &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (districtId && lgbId && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "Corporation") {
        if (
          corporationHead &&
          !uphcId &&
          !subareaId
        ) {
          return `corporation_council_id=${corporationHead}`;
        } else if (
          corporationHead &&
          uphcId &&
          !subareaId &&
          areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (corporationHead && uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } else if (accessLevelName === "UPHC") {
        if (
          uphcId && !subareaId && areaId === 1
        ) {
          return `phcId=${uphcId}`;
        } else if (uphcId && subareaId && areaId === 1) {
          return `villageId=${subareaId}`;
        }
      } 
    };
    const newUrl = url 
    // + "&" + queryParams();
    const response = await axiosInstance.get(newUrl);

    if (response.status === 200 && response.data && response.data.data) {
      return TokenDecrypt(response.data.data);
    }
    if (response.status === 404) {
      return [];
    }
    throw new Error("Failed to fetch Incentive data");
  } catch (error) {
    if (error.status === 404) {
      return [];
    }
    throw new Error(
      error.message || "Failed to fetch Incentive data"
    );
  }
};

export const getIncentiveBasedAshaSheet = async (
  languageId,
  districtId,
  talukaId,
  phcId,
  subcenterId,
  villageId,
  lgbId,
  areaType,
  uphcId,
  subareaId,
  corporationHead,
  incentiveFor,
  selectedMonth,
  selectedYear,
  districtIds,
  talukaIds,
  phcIds
) => {
  try {
    const accessLevel = [
      { id: 1, name: "State" },
      { id: 2, name: "District" },
      { id: 3, name: "Taluka" },
      { id: 4, name: "PHC" },
      { id: 5, name: "UPHC" },
      { id: 6, name: "Corporation" },
      { id: 7, name: "Multi District" },
    ];

    const access_level_id = sessionStorage.getItem("access_level_id");
    const filteredAccessLevel = accessLevel.filter(
      (level) => level.id === Number(access_level_id)
    );
    const incentive_role = sessionStorage.getItem("incentive_role");  
    const accessLevelName = filteredAccessLevel[0].name;
    const areaId = areaType === "Urban" ? 1 : 2;
    let url = `/api/xlSheet/ashalist/incentives?selectedMonth=${selectedMonth}&selectedYear=${selectedYear}&languageId=${languageId}&areaId=${areaId}&incentiveFor=${incentiveFor}&incentiveRole=${incentive_role}`;
    const queryParams = () => {
      if(incentive_role === 'PHC_MO'){
        return `phcId=${phcId}`
      }else {
        return `districts=${districtIds}&talukas=${talukaIds}&phcs=${phcIds}`
      }
    }
    const newUrl = url + "&" + queryParams();
     const response = await axiosInstance.get(newUrl, {
      responseType: "blob", 
    });
    
    return response;
  } catch (error) {
    if (error.status === 404) {
      return [];
    }
    throw new Error(
      error.message || "Failed to fetch Incentive data"
    );
  }
};
const getErrorMessage = (error, alternateMessage = "") => {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    return error.response.data.message;
  }
  return alternateMessage;
};

export const updateIncentiveActivityStatusService = async (
  payload,
  userCode,
  incentiveStatus,
  incentiveRole,
  incentiveFor
) => {
  try {
    const config = {
      method: "PUT",
      url: `/api/update/asha/incentiveStatus?userCode=${userCode}&incentiveStatus=${incentiveStatus}&incentiveRole=${incentiveRole}&incentiveFor=${incentiveFor}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      }
    };

    const response = await axiosInstance(config);

    toast.success(`${incentiveStatus} Successfully `, {
      style: successToastStyle,
    });

    return response.data;

  } catch (error) {

    toast.error(
      getErrorMessage(
        error,
        `Failed to ${incentiveStatus}!`
      ),
      {
        style: errorToastStyle,
      }
    );

    throw new Error(error.message || "Something went wrong");
  }
};

export const saveIncentivePaymentDetail = async (
  payload,
  languageId,
  areaId,
) => {
  try {
    const config = {
      method: "POST",
      url: `/api/upload/ashaIncentiveFile?languageId=${languageId}&areaId=${areaId}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      }
    };

    const response = await axiosInstance(config);

    toast.success(`Payment Details Saved Successfully `, {
      style: successToastStyle,
    });

    return response.data;

  } catch (error) {

    toast.error(
      getErrorMessage(
        error,
        `Failed to save payment details!`
      ),
      {
        style: errorToastStyle,
      }
    );

    throw new Error(error.message || "Something went wrong");
  }
};

export const getIncentiveDistrictList = async (languageId, stateId, incentiveFor,
  selectedMonth,selectedYear,incentive_role) => {
  try {
    let url = `/api/incentive/list/district?languageId=${languageId}&stateId=${stateId}&month=${selectedMonth}&year=${selectedYear}&incentiveRole=${incentive_role}&incentiveStatus=${incentiveFor}`;

    const response = await axiosInstance.get(url);
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "districtId", "districtName");
    }
    return [];
  } catch (error) {
    return [];
  }
};
export const getIncentiveTalukaList = async (
  languageId, districtId, incentiveFor,
  selectedMonth,selectedYear,incentive_role) => {
  try {
    let url = `/api/incentive/list/taluka?languageId=${languageId}&districtId=${districtId}&month=${selectedMonth}&year=${selectedYear}&incentiveRole=${incentive_role}&incentiveStatus=${incentiveFor}`;

    const response = await axiosInstance.get(url);
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "talukaId", "talukaName");
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getIncentiveUphcOrPhcList = async (
  languageId,talukaId,areaId,incentiveFor,
  selectedMonth,selectedYear,incentive_role ) => {
  let url;
  try {    
    const areaType = (areaId === "Urban" || areaId === "शहरी") ? 1 : 2;
    
    url = `/api/incentive/list/phc?languageId=${languageId}&areaId=${areaType}&talukaId=${talukaId}&month=${selectedMonth}&year=${selectedYear}&incentiveRole=${incentive_role}&incentiveStatus=${incentiveFor}`;
  
    const response = await axiosInstance.get(url);
    if (response.status === 200 && response.data && response.data.data) {
      return mappingFunction(response.data.data, "phcId", "phcName");
    }
    return [];
  } catch (error) {
    return [];
  }
};
